import { Action } from 'rete-history-plugin';
import Draggable from './draggable';

export default class Group {
  constructor(editor, el) {
    this.editor = editor;
    this.el = el;
    this.scale = 1;
    this.x = 0;
    this.y = 0;
    this.dragPosition = [0, 0];
    this.links = [];
    this.initView();
    this.dragStartTarget = null;
  }

  initView() {
    this.draggable = new Draggable(
      this.editor,
      this.el,
      e => this.onStart(e),
      (dx, dy) => this.onTranslate(dx, dy),
      e => this.onStop(e),
    );
  }

  onStart(e) {
    this.dragPosition = [this.x, this.y];
    this.dragStartTarget = e.target;
    this.linkedNodesView().map(nodeView => nodeView.onStart());
  }

  onTranslate(dx, dy) {
    const [x, y] = this.dragPosition;

    this.x = x + this.scale * dx;
    this.y = y + this.scale * dy;

    this.update();
    if (this.dragStartTarget.classList.contains('group-draggable')) {
      this.linkedNodesView().map(nodeView => nodeView.onDrag(dx, dy));
    }
  }

  onStop() {
    this.editor.trigger('addhistory', new GroupDragAction(this.editor, this.links))
  }

  update() {
    // nothing for now
  }

  destroy() {
    this.draggable.destroy();
  }

  linkTo(ids) {
    this.links = ids || [];
  }

  linkedNodesView() {
    return this.links
      .filter(id => this.editor.nodes.find(n => n.id === id))
      .map(id => this.editor.nodes.find(n => n.id === id))
      .map(node => this.editor.view.nodes.get(node));
  }
}

class GroupDragAction extends Action {
  constructor(editor, childIds) {
    super();
    // console.log('GroupDragAction::ctor')
    this.editor = editor;
    this.childIds = childIds;
  }

  undo() {
    // console.log('GroupDragAction::undo')
    // Undo translation for the children and the group itself
    for (let i = 0; i < this.childIds.length + 1; i++) {
      this.editor.trigger('undo');
    }
  }

  async redo() {
    // console.log('GroupDragAction::undo')
    // Redo translation for the children and the group itself
    for (let i = 0; i < this.childIds.length + 1; i++) {
      this.editor.trigger('redo');
    }
  }
}
